import { SET_BREAKPOINT } from "./actionTypes";

export const setBreakpoint = (windowBreakpoint) => {
  return {
    type: SET_BREAKPOINT,
    payload: windowBreakpoint,
  };
};
